import {DirectDebitChangePagePlain} from "./DirectDebitChangeBasePage";
import {AjaxError} from "rxjs/ajax";
import {INTERACTION_PROCESS_MTA_CHANGE_DIRECT_DEBIT} from "@falcon/services";
import {authorize, withRouter} from "@athena-portal/components";
import {DirectDebitInformationModal} from "../../../../../components/directDebit/DirectDebitInformationModal";

@authorize
export class DirectDebitChangePaymentPagePlain extends DirectDebitChangePagePlain {

    protected submitChanges(): void {
        this.setState({
            showOverlay: true
        })
        this.customerPortalService.updateDirectDebitPayment(this.policyNumber, this.state.newMandate)
            .subscribe(
                (response: any) => {
                    if (response instanceof AjaxError) {
                        if (response.status === 409) {
                            this.setState({
                                showBankValidationFailed: true,
                                accountNumberIsValid: false,
                                sortCodeIsValid: false,
                                showOverlay: false
                            })
                        }
                    } else if (!response.valid && response.ddUnsupported) {
                        this.setState({
                            ddUnsupported: response.ddUnsupported,
                            showBankValidationFailed: true,
                            accountNumberIsValid: false,
                            sortCodeIsValid: false,
                            showOverlay: false
                        })
                    } else {
                        window.sessionStorage.setItem("showPopup", "true");
                        window.sessionStorage.setItem("referrerJourney", INTERACTION_PROCESS_MTA_CHANGE_DIRECT_DEBIT);
                        this.props.navigate(this.previousPage);
                        this.setState({
                            showOverlay: false,
                            showBankValidationFailed: false
                        })
                    }
                }, () => {
                    this.setState({
                        showOverlay: false
                    });
                    console.log("Something went wrong");
                });
    }

    protected renderDirectDebitInformationModal() {
        return <DirectDebitInformationModal product={this.state.product} type={DirectDebitInformationModal.DDI_TYPE_PAYMENT}/>;
    }

    protected getPageTitle() {
        return 'Set up Direct Debit';
    }


}

export const DirectDebitChangePaymentPage = withRouter(DirectDebitChangePaymentPagePlain)
